export const loadJSWidthUrl = (url: string) =>
  new Promise((resolve, reject) => {
    const scripts = document.createElement("script");
    scripts.onload = () => {
      resolve("success");
    };
    scripts.onerror = reject;
    scripts.type = "module";
    scripts.src = url;
    document.documentElement.appendChild(scripts);
  });
